import { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./authContext/AuthContext";
import { useCompanyAccessStore } from "@/common/states/store/CompanyAccess";
import Loading from "../ui/loading/Loading";
import { useUser } from "@/common/services/users.api";

type Props = {
  children: ReactNode;
};

function PrivateRouteWithCompanyValidation({ children }: Props) {
  const { authReady } = useContext(AuthContext);
  const { companyAccess } = useCompanyAccessStore()
  const user = useUser()
  const isLoadingAccess = !authReady && companyAccess === undefined;
  const invalidAccess = !user && (companyAccess === undefined || companyAccess === null)

  if(isLoadingAccess) {
    return <Loading />
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (invalidAccess) {
    return <Navigate to="/login?error=Acesso inválido" />;
  }
  
  return <>{children}</>;
}

export default PrivateRouteWithCompanyValidation;
